import { useEffect } from 'react';

/**
 * Hook để bảo vệ nội dung website
 * - Vô hiệu hóa chuột phải
 * - Vô hiệu hóa các phím tắt (F12, Ctrl+Shift+I, Ctrl+U, Ctrl+S, Ctrl+C, Ctrl+A)
 * - Phát hiện DevTools
 * - Thêm watermark khi copy
 */
export const useContentProtection = () => {
  useEffect(() => {
    // TEMPORARILY DISABLED - Tạm thời vô hiệu hóa để dev có thể F12
    return () => {}; // Do nothing

    /* COMMENTED OUT FOR DEVELOPMENT
    // 1. Vô hiệu hóa chuột phải
    const disableRightClick = (e: MouseEvent) => {
      e.preventDefault();
      return false;
    };

    // 2. Vô hiệu hóa các phím tắt
    const disableKeyboardShortcuts = (e: KeyboardEvent) => {
      // F12
      if (e.key === 'F12') {
        e.preventDefault();
        return false;
      }

      // Ctrl+Shift+I (Inspect)
      if (e.ctrlKey && e.shiftKey && e.key === 'I') {
        e.preventDefault();
        return false;
      }

      // Ctrl+Shift+C (Element Selector)
      if (e.ctrlKey && e.shiftKey && e.key === 'C') {
        e.preventDefault();
        return false;
      }

      // Ctrl+Shift+J (Console)
      if (e.ctrlKey && e.shiftKey && e.key === 'J') {
        e.preventDefault();
        return false;
      }

      // Ctrl+U (View Source)
      if (e.ctrlKey && e.key === 'u') {
        e.preventDefault();
        return false;
      }

      // Ctrl+S (Save)
      if (e.ctrlKey && e.key === 's') {
        e.preventDefault();
        return false;
      }

      // Ctrl+A (Select All) - chỉ vô hiệu hóa ngoài input/textarea
      if (e.ctrlKey && e.key === 'a') {
        const target = e.target as HTMLElement;
        if (target.tagName !== 'INPUT' && target.tagName !== 'TEXTAREA') {
          e.preventDefault();
          return false;
        }
      }

      // Ctrl+C (Copy) - chỉ vô hiệu hóa ngoài input/textarea
      if (e.ctrlKey && e.key === 'c') {
        const target = e.target as HTMLElement;
        if (target.tagName !== 'INPUT' && target.tagName !== 'TEXTAREA') {
          e.preventDefault();
          return false;
        }
      }
    };

    // 3. Phát hiện DevTools
    let devtoolsOpen = false;
    const detectDevTools = () => {
      const threshold = 160;
      const widthThreshold = window.outerWidth - window.innerWidth > threshold;
      const heightThreshold = window.outerHeight - window.innerHeight > threshold;

      const isOpen = widthThreshold || heightThreshold;

      if (isOpen && !devtoolsOpen) {
        devtoolsOpen = true;
        showDevToolsWarning();
        document.body.classList.add('devtools-open');
      } else if (!isOpen && devtoolsOpen) {
        devtoolsOpen = false;
        hideDevToolsWarning();
        document.body.classList.remove('devtools-open');
      }
    };

    // Hiển thị cảnh báo DevTools
    const showDevToolsWarning = () => {
      let overlay = document.getElementById('devtools-warning-overlay');

      if (!overlay) {
        overlay = document.createElement('div');
        overlay.id = 'devtools-warning-overlay';
        overlay.className = 'devtools-warning-overlay';
        overlay.innerHTML = `
          <div class="warning-icon">⚠️</div>
          <h1>Cảnh báo bảo mật</h1>
          <p>Chức năng Developer Tools không được phép sử dụng trên trang web này.</p>
          <p>Vui lòng đóng Developer Tools để tiếp tục.</p>
          <p style="font-size: 16px; color: #888; margin-top: 20px;">
            Nội dung được bảo vệ bởi TukiLab
          </p>
        `;
        document.body.appendChild(overlay);
      }
    };

    // Ẩn cảnh báo DevTools
    const hideDevToolsWarning = () => {
      const overlay = document.getElementById('devtools-warning-overlay');
      if (overlay) {
        overlay.remove();
      }
    };

    // 4. Thêm watermark khi copy
    const addWatermarkOnCopy = (e: ClipboardEvent) => {
      const selection = window.getSelection();
      if (!selection) return;

      const selectedText = selection.toString();
      if (selectedText) {
        e.preventDefault();

        const watermark = `\n\n---\nNội dung từ: ${window.location.href}\n© ${new Date().getFullYear()} TukiLab. Bảo lưu mọi quyền.\n`;
        const textWithWatermark = selectedText + watermark;

        if (e.clipboardData) {
          e.clipboardData.setData('text/plain', textWithWatermark);
        }
      }
    };

    // 5. Vô hiệu hóa print screen (một phần)
    const disablePrintScreen = (e: KeyboardEvent) => {
      // Print Screen key
      if (e.key === 'PrintScreen') {
        navigator.clipboard.writeText('');
        alert('Chụp màn hình đã được vô hiệu hóa trên trang web này.');
      }

      // Ctrl+P (Print)
      if (e.ctrlKey && e.key === 'p') {
        e.preventDefault();
        alert('Chức năng in đã được vô hiệu hóa trên trang web này.');
        return false;
      }
    };

    // Đăng ký các event listeners
    document.addEventListener('contextmenu', disableRightClick);
    document.addEventListener('keydown', disableKeyboardShortcuts);
    document.addEventListener('keydown', disablePrintScreen);
    document.addEventListener('copy', addWatermarkOnCopy);

    // Kiểm tra DevTools định kỳ
    const devToolsInterval = setInterval(detectDevTools, 1000);

    // Debug detection - phát hiện console.log
    const consoleMethod = console.log;
    console.log = (...args: any[]) => {
      // Có thể thêm logic để phát hiện việc sử dụng console
      consoleMethod.apply(console, args);
    };

    // Cleanup
    return () => {
      document.removeEventListener('contextmenu', disableRightClick);
      document.removeEventListener('keydown', disableKeyboardShortcuts);
      document.removeEventListener('keydown', disablePrintScreen);
      document.removeEventListener('copy', addWatermarkOnCopy);
      clearInterval(devToolsInterval);
      hideDevToolsWarning();
      document.body.classList.remove('devtools-open');

      // Restore console.log
      console.log = consoleMethod;
    };
    END OF COMMENTED OUT CODE */
  }, []);

  return null;
};
